import React, { useContext } from "react";

export const Lotto90Context = React.createContext(null);

export const useLotto90 = () => {
    const ctx = useContext(Lotto90Context);
    if (!ctx) {
        throw new Error("useLotto90 must be used within a Lotto90Context.Provider");
    }
    return ctx;
};
